import React from 'react';
import one from '../Images/Nutritionist-bg.jpg'
import bg from '../Images/Nutritionist-mainbg.jpg'
function Nutritionist() {
  return (
    <div className="flex flex-col md:flex-row min-h-screen max-w-full mx-auto bg-[#fffaf7]">
      {/* Left Image */}
      <div className="flex-1 max-w-full md:max-w-1/2">
        <img
          src={one}
          alt="Young woman standing outdoors in black sweater and blue jeans with green foliage background"
          className="w-full h-[900px] md:h-full object-cover"
        />
      </div>

      {/* Right Text Section */}
      <div className="flex-1 max-w-full md:max-w-1/2 relative bg-[#fffaf7]">
        <div className="relative w-full h-full overflow-auto">
          {/* Background Pattern */}
          <img
            src={bg}
            alt="Light beige background pattern with outlines of fruits and leaves"
            className="absolute inset-0 w-full h-full object-contain opacity-10 pointer-events-none select-none"
          />

          {/* Content */}
          <div className="relative z-10 max-w-[600px] h-full px-10 py-16 md:py-24 overflow-y-auto">
            <h2 className="text-[25px] font-bold mb-5">
              How did you to decide to became a Nutritionist?
            </h2>
            <p className="mb-8 text-[20px] font-normal leading-relaxed quote">
              “Hi, <strong>I'm Niharika Jain</strong>, a Nutritionist and Dietitian. My journey into this field began with my own health struggles—I was overweight, weighing over 100 kg, and experienced PCOD, body pain, low Vitamin D levels, and constant hesitation about my well-being. These challenges motivated me to pursue nutrition courses so I could resolve my own health issues and help others facing similar problems.”
            </p>

            <h2 className="text-[25px] font-bold mb-5 mt-20">
              Why do you believe clients should come to you rather than another nutritionist?
            </h2>
            <p className="mb-8 text-[20px] font-normal leading-relaxed quote">
              I believe in personalization, as every individual’s body is unique. That’s why I carefully observe each person’s lifestyle in detail and design a diet plan that integrates seamlessly with their daily routine, ensuring better results and long-term sustainability.”
            </p>

            <button className="text-[20px] text-[#3a3a2f] font-normal border border-[#3a3a2f] rounded-full px-6 py-2.5 transition-colors duration-300 hover:bg-[#3a3a2f] hover:text-[#fffaf7]">
              Read More
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Nutritionist;
